import { render } from "./login-ciam.vue?vue&type=template&id=fb1b55c4"
import script from "./login-ciam.vue?vue&type=script&lang=js"
export * from "./login-ciam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__